import * as React from 'react'

import { computed, makeObservable, observable } from 'mobx'
import { observer } from 'mobx-react'

import Localization from '~/client/src/shared/localization/LocalizationManager'
import CustomDeliveryListFilter from '~/client/src/shared/types/CustomDeliveryListFilter'
import CustomWorkflowsFilter from '~/client/src/shared/types/CustomWorkflowFilter'
import { areObjectsEqual } from '~/client/src/shared/utils/util'

import '../SavedFilters.scss'

// localization: translated

interface IProps {
  customFilter: CustomDeliveryListFilter | CustomWorkflowsFilter
}

@observer
export default class FilterLabel extends React.Component<IProps> {
  @observable private customFilter:
    | CustomDeliveryListFilter
    | CustomWorkflowsFilter = null
  public constructor(props: IProps) {
    super(props)

    this.customFilter = props.customFilter
    makeObservable(this)
  }

  public componentDidUpdate(): void {
    if (!areObjectsEqual(this.customFilter, this.props.customFilter)) {
      this.customFilter = this.props.customFilter
    }
  }

  public render() {
    const { customFilter } = this.props
    return (
      <>
        {customFilter.name}
        <span className="text extra-large light ml5">
          ({Localization.translator.xFilters(this.filtersCount)})
        </span>
      </>
    )
  }

  @computed
  private get filtersCount(): number {
    if (!this.customFilter) {
      return 0
    }

    if (Array.isArray(this.customFilter.filtersByFilterType)) {
      return this.customFilter.filtersByFilterType.reduce(
        (sum, filter) => sum + (filter?.values?.length || 0),
        0,
      )
    }

    const filtersByType = this.customFilter.filtersByFilterType as {
      [key: string]: string[]
    }

    return Object.values(filtersByType).reduce(
      (sum, values) => sum + values?.length,
      0,
    )
  }
}
